import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { assetUrl } from "@shared/helper/asset-url";

@Component({
  selector: "app-platform-news-modal",
  templateUrl: "./platform-news-modal.component.html",
  styleUrls: ["./platform-news-modal.component.scss"],
  standalone: false
})
export class PlatformNewsModalComponent {
  imageBannerPath: string = assetUrl("images/temp/banner_news.png");
  image2Path: string = assetUrl("images/temp/autoglass-logo.png");

  constructor(private matDialogRef: MatDialogRef<PlatformNewsModalComponent>) {}

  closeDialog(): void {
    this.matDialogRef.close();
  }
}
